import { Stack, Group } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { AfaModal, AfaAlert, AfaButton } from '../../ui';

interface LogoutModalProps {
  opened: boolean;
  onClose: () => void;
  logOut: () => void;
}

export function LogoutModal({ opened, onClose, logOut }: LogoutModalProps) {
  const navigate = useNavigate();

  return (
    <AfaModal
      opened={opened}
      onClose={onClose}
      title="Tancar sessió"
      size="md"
      centered
    >
      <Stack mt={'sm'}>
        <div style={{ width: '100%' }}>
          <AfaAlert type="info" variant="light" title="Tancar sessió">
            Estàs segur que vols tancar la sessió?
          </AfaAlert>
        </div>
      </Stack>

      <Group justify="flex-end" mt="md" gap="md">
        <AfaButton variant="filled" color="red" onClick={() => {
          logOut();
          navigate('/');
        }}>
          Tancar sessió
        </AfaButton>
      </Group>
    </AfaModal>
  );
}
